"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionEditorQuestionSet = void 0;
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importDefault(require("react"));
exports.QuestionEditorQuestionSet = react_1.default.memo(() => {
    return react_1.default.createElement(Vertical_1.default, null);
});
exports.default = exports.QuestionEditorQuestionSet;
